import RestClient from '../RestClient/RestClient';
import AccountApiConstants from './AccountApiConstants';

const getHostConfig = (config) => {
    const context = RestClient.getContext();
    /* istanbul ignore else */
    if (context && context.hostname && context.hostname.indexOf('test') === -1) {
        config.host = 'account-api.jcpenney.com';
        config.isXCloudHeaderRequired = false;
    }
    return config;
};

export const getStoresWithRange = (params) => { //eslint-disable-line
    let config = {
        url: `${AccountApiConstants.STORES}`,
        acceptVersion: '5',
        version: '/v1', // TODO: CHANGE to v5 when start working
        isXCloudHeaderRequired: true,
        host: 'account-api-test.jcpenney.com',
        XForwardedChannelHeaderHost: true,
    };
    config = getHostConfig(config);
    config.params = params.payload;

    return RestClient.get(config).then(
        /* istanbul ignore next */
        (res) => res
    );
};
